import Api from '../abstract';

export let CREATE = (params, successCallback, errorCallback) => {
    let url = `/user/setting/user`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let DETAIL = (successCallback, errorCallback) => {
    let url = `/user/setting/user`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};
